import * as locale from '../locale'
/* global chrome */
export const init = (action, store, drivers) => {
  const promises = [
    locale.load(action, store, drivers),
  ]
  Promise.all(promises).then(() => {
    console.log('ready')
    store.ui.ready.set(true)
    if (!action.payload.isAuthorized) {
      console.log('unauthorized')
      drivers.router.push('unauthorized')
      return;
    }
    var chromeExtensionId = drivers.router.getQueryParam('chromeExtensionId')
    console.log('send message - chromeExtensionId', chromeExtensionId)
    if (chromeExtensionId && chrome) {
      chrome.runtime.sendMessage(chromeExtensionId, {
        type: 'AUTH',
        token: store.config.keycloak.get().token,
        refreshToken: store.config.keycloak.get().refreshToken,
        keycloakClientId: store.config.keycloakConfig.get().keycloakClientKey,
      }) // eslint-disable-line
    }
    setTimeout(() => drivers.window.close(), 2000)
  })
}

